import React, { useState, useEffect } from "react";
import {
  Typography,
  Grid,
  Card,
  CardContent,
  Box,
  Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import Modals from "../../components/modal";
import CustomUnicefTextField from "../../components/controls/CustomUnicefTextField";

// Material UI Icons
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import PostAddIcon from '@material-ui/icons/PostAdd';
import PregnantWomanIcon from "@material-ui/icons/PregnantWoman";
import ChildCareIcon from "@material-ui/icons/ChildCare";
import FavoriteIcon from "@material-ui/icons/Favorite";
import GroupIcon from "@material-ui/icons/Group";
import WcIcon from "@material-ui/icons/Wc";
import LocalHospitalIcon from "@material-ui/icons/LocalHospital";
import ListAltIcon from '@material-ui/icons/ListAlt';

import {dailyEntryData} from '../../modals/dailyentry'

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  content: {
    flex: 1,
    padding: "15px",
  },
  card: {
    borderRadius: 20,
    color: "white",
    textAlign: "center",
    marginBlock: "10px",
    width: "80%",
    height: "150px",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&:hover": {
      transform: "translateY(-5px)",
      boxShadow: "0 6px 16px rgba(0,0,0,0.3)",
    },
    padding: "20px",
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  icon: {
    fontSize: 50, // make icons really big
    color: "rgba(255,255,255,0.95)",
  },
}));

const services = [
  { name: "Register Patients", count: '-', color: "#5A2E54", icon: PostAddIcon },
  { name: "ANC", count: '-', color: "#5A2E54", icon: PregnantWomanIcon },
  { name: "Delivery", count: '-', color: "#5A2E54", icon: ChildCareIcon },
  { name: "PNC", count: '-', color: "#5A2E54", icon: FavoriteIcon },
  { name: "FP", count: '-', color: "#8C628B", icon: GroupIcon },
  { name: "RH", count: '-', color: "#9D739C", icon: WcIcon },
  { name: "GM", count: '-', color: "#AE85AD", icon: LocalHospitalIcon },
  { name: "LAB", count: '-', color: "#BF96BE", icon: ListAltIcon },
];

export default function UIDailyReport() {

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const classes = useStyles();

  const checkButtonHandle = async() => {
    setLoading(true)
    const a = {
      orgID: sessionStorage.getItem('org'),
      projID: sessionStorage.getItem('project'),
      sDate: startDate,
      eDate: endDate
    }
    const dailyData = await dailyEntryData(a)
    if(dailyData.status==200)
    {
      setData(dailyData.data.data.dailyEntryData)
      const data = dailyData.data.data.dailyEntryData
      services[0].count = data[0].TOTALTRANSACTION
      services[1].count = data[1].TOTALTRANSACTION
      services[2].count = data[2].TOTALTRANSACTION
      services[3].count = data[3].TOTALTRANSACTION
      services[4].count = data[4].TOTALTRANSACTION
      services[5].count = data[5].TOTALTRANSACTION
      services[6].count = data[6].TOTALTRANSACTION
      services[7].count = data[7].TOTALTRANSACTION
    }
    setLoading(false)
  }

  return (
    <div className={classes.root}>
      <Typography variant="h5" align="center" style={{ color: '#53344d', fontWeight: 'bold', padding: '1%' }}>
              Daily Data Entry Transitions </Typography>
      <Modals open={loading} />
      {/* Header */}
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        style={{ paddingLeft: "1%", paddingRight: "1%",marginTop: "20px" }}
      >
        <Grid item xs={3} sm={2} md={2}>
          <CustomUnicefTextField
            id="filled-basic"
            type="date"
            size="small"
            style={{ width: "90%" }}
            label="Start Date"
            variantText="filled"
            InputLabelProps={{
              style: { color: "#482642" },
              shrink: true,
            }}
            onChange={(e) => setStartDate(e.target.value)}
            value={startDate}
          />
        </Grid>
        -
        <Grid item xs={3} sm={2} md={2}>
          <CustomUnicefTextField
            id="filled-basic"
            type="date"
            size="small"
            style={{ width: "90%" }}
            label="End Date"
            variantText="filled"
            InputLabelProps={{
              style: { color: "#482642" },
              shrink: true,
            }}
            onChange={(e) => setEndDate(e.target.value)}
            value={endDate}
          />
        </Grid>
        <Grid item xs={1} sm={1} md={1}>
          <Button
            variant="contained"
            size="large"
            disabled={!((startDate && endDate))}
            style={{
              background: !((startDate && endDate)) ? "lightgray" : "#482642",
              color: !((startDate && endDate)) ? "#482642" : "#fff",
              width: "90%",
            }}
          onClick={checkButtonHandle} 
          >
            Check
          </Button>
        </Grid>
      </Grid>
      {/* Main Content */}
      <Box className={classes.content}>
        <Grid container spacing={3}>
          {services.map((service, index) => {
            const IconComponent = service.icon;
            return (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Card className={classes.card} style={{ background: service.color }}>
                  <CardContent className={classes.cardContent}>
                    <IconComponent className={classes.icon} />
                    <Typography variant="h6">{service.name}</Typography>
                    <Typography variant="h5" style={{ fontWeight: "bold" }}>
                      {service.count}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </div>
  );
}
